"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var LinksDisplayGrid_1 = require("../components/sharedDisplayGrid/LinksDisplayGrid");
var LayoutComponents_1 = require("./LayoutComponents");
var VizPortalStyles_1 = require("./VizPortalStyles");
exports.descriptionMaxHeight = 60;
exports.ColumnDetailsPane = LayoutComponents_1.divWithStyle('ColumnDetailsPane', __assign({}, VizPortalStyles_1.vizPortalFontStyle, { fontSize: widgets_1.TabStyles.Typography.Sizing.Default }));
exports.ColumnDetailsColumnName = LayoutComponents_1.divWithStyle('ColumnDetailsColumnName', {
    fontSize: widgets_1.TabStyles.Typography.Sizing.XLarge,
});
exports.ColumnDetailsTypeRow = LayoutComponents_1.divWithStyle('ColumnDetailsTypeRow', {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: widgets_1.TabStyles.Spacing.DefaultSpace,
});
exports.ColumnDetailsProperties = LayoutComponents_1.divWithStyle('ColumnDetailsProperties', {
    display: 'table',
    paddingTop: widgets_1.TabStyles.Spacing.DefaultSpace,
    width: '100%',
});
exports.ColumnDetailsTextAreaWrapper = LayoutComponents_1.divWithStyle('ColumnDetailsTextAreaWrapper', {
    display: 'flex',
    height: 64,
});
exports.SaveAndCancelButtonsWrapper = LayoutComponents_1.divWithStyle('SaveAndCancelButtonsWrapper', {
    position: 'relative'
});
exports.SaveAndCancelButtonsFlexWrapper = LayoutComponents_1.divWithStyle('SaveAndCancelButtonsFlexWrapper', {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 10,
    marginLeft: widgets_1.TabStyles.Spacing.DefaultSpace
});
exports.columnDetailsTextAreaStyle = {
    marginTop: 10,
    fontSize: widgets_1.TabStyles.Typography.Sizing.Default,
    // tslint:disable-next-line: deprecation //TODO: figure out what to do here
    fontFamily: widgets_1.TabStyles.Typography.FontFamily,
    color: widgets_1.TabStyles.Typography.Color.Primary,
    resize: 'none',
    outline: 'none',
    flex: 1,
};
exports.ColumnDetailsProperty = LayoutComponents_1.divWithStyle('ColumnDetailsProperty', {
    display: 'table-row',
});
exports.ColumnDetailsLabel = LayoutComponents_1.divWithStyle('ColumnDetailsLabel', {
    display: 'table-cell',
    padding: widgets_1.TabStyles.Spacing.DefaultSpace,
    color: widgets_1.TabStyles.Typography.Color.Secondary,
    textAlign: 'right',
    whiteSpace: 'nowrap',
});
exports.ColumnDetailsDescriptionValue = LayoutComponents_1.divWithStyle('ColumnDetailsDescriptionValue', {
    display: 'table-cell',
    padding: widgets_1.TabStyles.Spacing.DefaultSpace,
    overflowY: 'auto',
    wordBreak: 'break-word',
});
exports.ColumnTableCell = LayoutComponents_1.divWithStyle('ColumnTableCell', {
    display: 'table-cell',
});
exports.ColumnDetailsPlaceholder = LayoutComponents_1.divWithStyle('FieldDetailsPlaceholder', {
    fontStyle: 'italic',
    color: widgets_1.TabStyles.Typography.Color.Secondary,
});
exports.columnFieldsWrapperMaxRows = 4.5;
exports.ColumnFieldsWrapper = LayoutComponents_1.divWithStyle('ColumnFieldsWrapper', {
    width: '100%',
    lineHeight: LinksDisplayGrid_1.rowHeight + "px",
    verticalAlign: 'top',
    display: 'table-cell',
    padding: widgets_1.TabStyles.Spacing.DefaultSpace,
    $nest: {
        '> div': {
            height: 'inherit',
            maxHeight: LinksDisplayGrid_1.rowHeight * exports.columnFieldsWrapperMaxRows,
            overflow: 'auto',
        }
    }
});
//# sourceMappingURL=ColumnDetailsStyles.js.map